import { theme } from '@squire/ui';

import { isWeb } from '@/utils/getPlatform';

/** Columns of the service grid: 2 on native, up to 4 on wide web screens. */
export function getServiceGridColumns(screenWidth: number): number {
  if (!isWeb()) return 2;
  if (screenWidth >= theme.breakpoints.tablet) return 4;
  if (screenWidth >= 500) return 3;
  return 2;
}
